import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, catchError, map, of } from 'rxjs';
import { UserPortalService } from '../../../shared/service/user-portal/user-portal.service';
import { AuthService } from 'src/app/shared/service';

@Injectable({
  providedIn: 'root'
})
export class PasswordGuard  {

  constructor(
    private bdpAuthService: AuthService,
    private userService: UserPortalService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.userService.isPasswordExpired().pipe(map((isExpired: any) => {
      if (isExpired) {
        this.bdpAuthService.forceChangePassowrdRedirect();
        return false;
      }
      return true;
    }), catchError((error) => {
      return of(false);
    }));
  }

}
